import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {Route} from '@react-navigation/native';
import {contentSelector} from '../../redux/selectors/resources';
import {profileHolderCardIssuer} from '../../redux/selectors/profile';

export const TransportServicesScreen = ({route}: {route: Route<string>}) => {
  const content = useSelector(contentSelector());
  const cardIssuer = useSelector(profileHolderCardIssuer());

  return <View content={content} route={route} cardIssuer={cardIssuer} />;
};
